import {
    add as _add,
    getList as _getList,
    update as _update,
    getOneById as _getOneById,
    deleteAll as _deleteAll,
    patchAsync as _patchAsync,
} from "../../api";
import { dateToString } from "utils/dateUtils";

const BASE_URL = "/campaigns";
const DEFAULT_LIST_DATA = {
    filter: {},
    orderBy: "stampCreationDatetime",
    orderDirection: "desc",
    pageNumber: 0,
    pageSize: 10,
};

function normalizeCampaignData(data) {
    const {
        startDatetime: startDatetimeRaw,
        endDatetime: endDatetimeRaw,
        stampCreationDatetime: stampCreationDatetimeRaw,
        stampModificationDatetime: stampModificationDatetimeRaw,
    } = data;

    // Backend serializes datetimes either as ISO-8601 local strings or millis;
    // `new Date` handles both so the UI always works with real Date objects.
    const startDatetime = startDatetimeRaw ? new Date(startDatetimeRaw) : null;
    const endDatetime = endDatetimeRaw ? new Date(endDatetimeRaw) : null;
    const stampCreationDatetime = stampCreationDatetimeRaw ? new Date(stampCreationDatetimeRaw) : null;
    const stampModificationDatetime = stampModificationDatetimeRaw ? new Date(stampModificationDatetimeRaw) : null;

    return {
        ...data,
        startDatetime,
        endDatetime,
        stampCreationDatetime,
        stampModificationDatetime,
        startDatetimeString: startDatetime ? dateToString(startDatetime) : "--",
        endDatetimeString: endDatetime ? dateToString(endDatetime) : "--",
        stampCreationDatetimeString: stampCreationDatetime ? dateToString(stampCreationDatetime) : "--",
        stampModificationDatetimeString: stampModificationDatetime ? dateToString(stampModificationDatetime) : "--",
    };
}

function normalizeData(data) {
    return data.map(normalizeCampaignData);
}

export function getList({ onSuccess, onInfo, onError, data = DEFAULT_LIST_DATA }) {
    _getList({ url: BASE_URL, data, onSuccess, onInfo, onError, normalizer: normalizeData });
}

export function add({ payload, onSuccess, onError }) {
    _add({ url: BASE_URL, data: payload, onSuccess, onError });
}

export function update({ payload, onSuccess, onError }) {
    _update({ url: `${BASE_URL}/${payload.id}`, data: payload, onSuccess, onError });
}

export function getOneById({ id, onSuccess, onError }) {
    _getOneById({
        url: `${BASE_URL}/${id}`,
        onSuccess,
        onError,
        normalizer: normalizeCampaignData,
    });
}

export function deleteAll({ ids, onSuccess, onError }) {
    _deleteAll({ url: BASE_URL, data: { ids }, onSuccess, onError });
}

export function setInactiveAsync(id) {
    return _patchAsync({ url: `${BASE_URL}/${id}:inactive` });
}

export function setActiveAsync(id) {
    return _patchAsync({ url: `${BASE_URL}/${id}:activate` });
}
